export default function nl2br(string) {
  if (typeof string !== "string") {
    if (typeof string?.toString === "function") {
      return nl2br(string.toString())
    }

    return ""
  }

  return string.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, "$1<br/>$2")
}
